import {Component, forwardRef, HostListener, Input} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUISearchPillComponent),
            multi: true
        }
    ],
    selector: "fui-search-pill",
    styleUrls: ["./search-pill.component.scss"],
    templateUrl: "./search-pill.component.html"
})
export class FUISearchPillComponent extends FUIAbstractPill {
    /**
     * Indicates if the pill can be removed
     */
    @Input() public removable: boolean;
}
